import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { AddMfaBackup, OauthAEMConfig } from '../../../models';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class CancelMethodPairingService {
  cancelMethodPairingHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.cancelDevicePairing+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  cancelMethodPairing = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<AddMfaBackup> => {
    const cancelUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const cancelMethodPairingUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: cancelUrl
      }
    ];

    return new ApiBuilder<undefined, AddMfaBackup>(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(cancelMethodPairingUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.cancelMethodPairingHeader)
      .errorHandler(this._errorHandler)
      .library('CANCEL_METHOD_PAIRING_SERVICE')
      .withCredentials(true)
      .create();
  };
}
